export const GET_RESOURCE_ARCHIVE_FOLDERS = 'GET_RESOURCE_ARCHIVE_FOLDERS'
export const GET_RESOURCE_ARCHIVE_FOLDER = 'GET_RESOURCE_ARCHIVE_FOLDER'
export const ADD_RESOURCE_ARCHIVE_FOLDER = 'ADD_RESOURCE_ARCHIVE_FOLDER'
export const UPDATE_RESOURCE_ARCHIVE_FOLDER = 'UPDATE_RESOURCE_ARCHIVE_FOLDER'
export const DELETE_RESOURCE_ARCHIVE_FOLDER = 'DELETE_RESOURCE_ARCHIVE_FOLDER'
